export default __webpack_public_path__ + "static/media/reg.45888702.svg";